import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getCabins = async () => {
  const res = await axios.get(`${API}/cabins`);
  return res.data;
};

export const createReservation = async (payload) => {
  const res = await axios.post(`${API}/reservations`, payload);
  return res.data;
};

export const WHATSAPP_NUMBER = "5511920017434";

// ---- Admin ----
const tokenKey = "rp_admin_token";
export const getToken = () => localStorage.getItem(tokenKey);
export const setToken = (t) => localStorage.setItem(tokenKey, t);
export const clearToken = () => localStorage.removeItem(tokenKey);

const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = async (email, password) => {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  return res.data;
};

export const adminMe = async () => {
  const res = await axios.get(`${API}/auth/me`, authHeader());
  return res.data;
};

export const adminGetReservations = async () => {
  const res = await axios.get(`${API}/admin/reservations`, authHeader());
  return res.data;
};

export const adminGetStats = async () => {
  const res = await axios.get(`${API}/admin/stats`, authHeader());
  return res.data;
};
